module.exports = __webpack_public_path__ + "static/media/1.32f4cae7.png";